"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FemaleClipPath = ({ x, clipId }) => {
    return (react_1.default.createElement("clipPath", { id: clipId },
        react_1.default.createElement("rect", { width: "620", height: "1370", x: x, y: "0" })));
};
exports.default = FemaleClipPath;
//# sourceMappingURL=FemaleClipPath.js.map